<template>
  <div class="quota-wrap">
    <div class="quota-box">
      <img 
        src="@/assets/images/group.gif" 
        alt="group"
        class="group-img"
      />
      <div class="quota-group">
        <div class="item">
          <div class="value">
             <span class="quota-value">{{personalQuota.approvalTotal}}</span>
             <span class="unit">次</span>
          </div>
          <div class="label">
            审批总量
            <el-tooltip :content="quotaTip.approvalTotal" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
        </div>
        <div class="item">
          <div class="value">
            <span class="quota-value">{{approvalTimeAvgFormate}}</span>
            <span class="unit">{{timeUnit}}</span>
          </div>
          <div class="label">
            审批平均耗时
            <el-tooltip :content="quotaTip.approvalTimeAvg" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
        </div>
        <div class="item">
          <div class="value">
            <span class="quota-value">{{personalQuota.approvalTimeFastPercent}}</span>
            <span class="unit"></span>
          </div>
          <div class="label">
            平均耗时比他人快
            <el-tooltip :content="quotaTip.approvalTimeFastPercent" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
        </div>
        <div class="item">
          <div class="value approval-awit-num" @click="goApprovalWait">
            <span class="quota-value">{{personalQuota.approvalNum}}</span>
            <span class="unit">个</span>
          </div>
          <div class="label" @click="goApprovalWait">
            <span class="approval-wait">待审批 </span>
            <el-tooltip :content="quotaTip.approvalNum" placement="top">
              <i class="el-icon-question" @click.stop></i>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {quotaTip} from './options'
export default {
  data() {
    return {
      personalQuota: {},
      quotaTip: quotaTip,
      timeUnit: '',
      approvalTimeAvgFormate: ''
    }
  },
  created() {
    this.getPersonalQuota()
  },
  methods: {
    getPersonalQuota() {
      _api.dataCenter.personalQuota()
        .then(data => {
           this.personalQuota = data
           this.approvalTimeAvgHandler()
        })
    },
    approvalTimeAvgHandler() {
      const time = this.personalQuota.approvalTimeAvg
      if (time > (3600 * 24)) {
        this.approvalTimeAvgFormate = Math.round(time / (3600 * 24) * 100) / 100;
        this.timeUnit = '天'
      } else if (time > 3600) {
        this.approvalTimeAvgFormate = Math.round(time / 3600 * 100) / 100;
        this.timeUnit = '小时'
      } else {
        this.approvalTimeAvgFormate = Math.ceil((time / 10) / 6)
        this.timeUnit = '分钟'
      }
    },
    goApprovalWait() {
      setTimeout(() => {
        this.$router.push( `/approval/wait`);
      }, 0)
      this.$router.push('/')
    },
  }
}
</script>

<style lang="scss" scoped>
.quota-wrap {
  height: 148px;
  background: #14b866;
  .group-img {
    object-fit: cover;
    width: 148px;
    height: 148px;
    margin-left: 20px;
  }
  .quota-box {
    display: flex;
    .quota-group {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .item {        
        flex: 1;
        padding: 20px 0;
        text-align: center;
        &:nth-last-child(2) {
          margin-right: 40px;
        }
        &:last-child {
          border-left: 2px solid #39c57b;
        }
        .value {
          color: #FFFFFF;
          margin-bottom: 7px;
          line-height: 22px;
          &.approval-awit-num {
            cursor: pointer;
          }
          .quota-value {
            font-size: 26px;
            font-weight: 600;
            margin-right: 4px;
          }
          .unit {
            font-size: 14px;
          }
        }
        .label {
          opacity: 0.8;
          font-size: 18px;
          color: #FFFFFF;
          line-height: 22px;
          .el-icon-question { 
            font-size: 18px;
            opacity: 0.8;
            &:hover {
              opacity: 1;
              cursor: pointer;
            }
          }
          .approval-wait {
            cursor: pointer;
            font-size: inherit;
          }
        }
      }
    }
  }
}
</style>